"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTemplate = exports.isChildTemplate = exports.isMasterTemplateUI = exports.isMasterTemplate = exports.AdditionalPlayerItemProperty = exports.TemplateOrientation = exports.TemplateChain = exports.CreateTemplateType = exports.TemplateType = exports.CurrencyInputUnit = exports.CurrencyOutputUnit = exports.ProductProperty = exports.ComponentRuleOperator = exports.ComponentType = exports.MomentLocale = void 0;
var MomentLocale;
(function (MomentLocale) {
    MomentLocale["fi"] = "fi";
    MomentLocale["en"] = "en";
    MomentLocale["sv"] = "sv";
})(MomentLocale = exports.MomentLocale || (exports.MomentLocale = {}));
var ComponentType;
(function (ComponentType) {
    ComponentType["div"] = "div";
    ComponentType["text"] = "text";
    ComponentType["image"] = "image";
    ComponentType["video"] = "video";
    ComponentType["date"] = "date";
    ComponentType["listPrice"] = "listPrice";
    ComponentType["lunchGroups"] = "lunchGroups";
    ComponentType["lunchGroup"] = "lunchGroup";
    ComponentType["lunchGroupPrice"] = "lunchGroupPrice";
    ComponentType["lunchItemsContainer"] = "lunchItemsContainer";
    ComponentType["lunchItemContainer"] = "lunchItemContainer";
    ComponentType["lunchItemSpecialDiet"] = "lunchItemSpecialDiet";
    ComponentType["priceItems"] = "priceItems";
    ComponentType["fishItems"] = "fishItems";
    ComponentType["meatItems"] = "meatItems";
    ComponentType["keskoFeedOffers"] = "keskoFeedOffers";
    ComponentType["keskoProductOffers"] = "keskoProductOffers";
    /** Container component for productData components in multi product templates */
    ComponentType["products"] = "products";
    /** Component can be used to map product data based on schema structure */
    ComponentType["productData"] = "productData";
    ComponentType["qrCode"] = "qrCode";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var ComponentRuleOperator;
(function (ComponentRuleOperator) {
    ComponentRuleOperator["exists"] = "exists";
    ComponentRuleOperator["notExists"] = "notExists";
    ComponentRuleOperator["contains"] = "contains";
    ComponentRuleOperator["notContains"] = "notContains";
    ComponentRuleOperator["equals"] = "equals";
    ComponentRuleOperator["lessThan"] = "lessThan";
    ComponentRuleOperator["greaterThan"] = "greaterThan";
    ComponentRuleOperator["true"] = "true";
    ComponentRuleOperator["false"] = "false";
})(ComponentRuleOperator = exports.ComponentRuleOperator || (exports.ComponentRuleOperator = {}));
/** Properties to use as conditions in template components */
var ProductProperty;
(function (ProductProperty) {
    ProductProperty["agents"] = "agents";
    ProductProperty["agentStrength"] = "agentStrength";
    ProductProperty["comparisonUnit"] = "comparisonUnit";
    ProductProperty["comparisonString"] = "comparisonString";
    ProductProperty["country"] = "country";
    ProductProperty["deposit"] = "deposit";
    ProductProperty["description"] = "description";
    ProductProperty["discount"] = "discount";
    ProductProperty["discountBatchSize"] = "discountBatchSize";
    ProductProperty["discountBatchUnit"] = "discountBatchUnit";
    ProductProperty["discountPrice"] = "discountPrice";
    ProductProperty["discountValidString"] = "discountValidString";
    ProductProperty["marketer"] = "marketer";
    ProductProperty["name"] = "name";
    ProductProperty["packageSize"] = "packageSize";
    ProductProperty["packageMultiplier"] = "packageMultiplier";
    ProductProperty["packageUnit"] = "packageUnit";
    ProductProperty["price"] = "price";
    ProductProperty["scaleNumber"] = "scaleNumber";
    ProductProperty["showPercentage"] = "showPercentage";
    ProductProperty["unit"] = "unit";
    ProductProperty["unitPrice"] = "unitPrice";
    ProductProperty["unitPriceUnit"] = "unitPriceUnit";
    ProductProperty["useBatchPrice"] = "useBatchPrice";
})(ProductProperty = exports.ProductProperty || (exports.ProductProperty = {}));
var CurrencyOutputUnit;
(function (CurrencyOutputUnit) {
    CurrencyOutputUnit["integers"] = "integers";
    CurrencyOutputUnit["decimals"] = "decimals";
    CurrencyOutputUnit["bothWithComma"] = "bothWithComma";
})(CurrencyOutputUnit = exports.CurrencyOutputUnit || (exports.CurrencyOutputUnit = {}));
var CurrencyInputUnit;
(function (CurrencyInputUnit) {
    CurrencyInputUnit["priceString"] = "priceString";
    CurrencyInputUnit["decimals"] = "decimals";
})(CurrencyInputUnit = exports.CurrencyInputUnit || (exports.CurrencyInputUnit = {}));
var TemplateType;
(function (TemplateType) {
    TemplateType["retail"] = "retail";
    TemplateType["lunch"] = "lunch";
    TemplateType["fish"] = "fish";
    TemplateType["meat"] = "meat";
    TemplateType["offer"] = "offer";
    TemplateType["info"] = "info";
    TemplateType["feed"] = "feed";
})(TemplateType = exports.TemplateType || (exports.TemplateType = {}));
var CreateTemplateType;
(function (CreateTemplateType) {
    CreateTemplateType["retail"] = "retail";
    CreateTemplateType["info"] = "info";
    CreateTemplateType["lunch"] = "lunch";
    CreateTemplateType["fish"] = "fish";
    CreateTemplateType["meat"] = "meat";
    CreateTemplateType["feed"] = "feed";
})(CreateTemplateType = exports.CreateTemplateType || (exports.CreateTemplateType = {}));
var TemplateChain;
(function (TemplateChain) {
    TemplateChain["sok"] = "sok";
    TemplateChain["kesko"] = "kesko";
})(TemplateChain = exports.TemplateChain || (exports.TemplateChain = {}));
var TemplateOrientation;
(function (TemplateOrientation) {
    TemplateOrientation["landscape"] = "landscape";
    TemplateOrientation["portrait"] = "portrait";
})(TemplateOrientation = exports.TemplateOrientation || (exports.TemplateOrientation = {}));
/**
 * Property names for additional properties from Player Item to be displayed on Template
 */
var AdditionalPlayerItemProperty;
(function (AdditionalPlayerItemProperty) {
    AdditionalPlayerItemProperty["description"] = "description";
    AdditionalPlayerItemProperty["discountPercentage"] = "discountPercentage";
    AdditionalPlayerItemProperty["discountPrice"] = "discountPrice";
    AdditionalPlayerItemProperty["name"] = "name";
    AdditionalPlayerItemProperty["price"] = "price";
    AdditionalPlayerItemProperty["showPercentage"] = "showPercentage";
    AdditionalPlayerItemProperty["useBatchPrice"] = "useBatchPrice";
    AdditionalPlayerItemProperty["useBatchPercentage"] = "useBatchPercentage";
    AdditionalPlayerItemProperty["usePackagePrice"] = "usePackagePrice";
})(AdditionalPlayerItemProperty = exports.AdditionalPlayerItemProperty || (exports.AdditionalPlayerItemProperty = {}));
/** Typeguard for MasterTemplate */
exports.isMasterTemplate = (template) => template === null || template === void 0 ? void 0 : template.childTemplateIds;
/** Typeguard for MasterTemplateUI */
exports.isMasterTemplateUI = (template) => (template === null || template === void 0 ? void 0 : template.childTemplateIds) && (template === null || template === void 0 ? void 0 : template.childTemplates);
/** Typeguard for ChildTemplate */
exports.isChildTemplate = (template) => template.isChildTemplate;
/** Typeguard for normal template */
exports.isTemplate = (template) => !exports.isMasterTemplate(template) && !exports.isChildTemplate(template);
//# sourceMappingURL=templates.js.map